<script lang="ts">
    import CN from "classnames";

    export let stepsNames: string[];
    export let currentStepName: string;

    $: currentStepIndex = stepsNames.findIndex(
        (name) => name === currentStepName
    );
</script>

<div class="gw-stepper-progress">
    <ul class="gw-stepper-progress__steps">
        {#each stepsNames as step, i}
            <li class={CN("gw-stepper-progress__step-outer")} data-title={step}>
                <div
                    class="gw-stepper-progress__step-inner"
                    style={`--progress-width: ${
                        i < currentStepIndex + 1 ? "100%" : "0%"
                    }`}
                />
            </li>
        {/each}
    </ul>
</div>

<style lang="postcss">
    .gw-stepper-progress {
        &__steps {
            display: flex;
            gap: 1em;
            list-style: none;
            margin: 0;
            padding: 0;
        }

        &__step-outer {
            flex: 1 1 0px;
            display: block;
            height: 8px;
            border-radius: 4px;
            background: var(--Grey-500, #98a2b3);
            overflow: hidden;
        }

        &__step-inner {
            display: block;
            width: var(--progress-width, 0%);
            height: 8px;
            background: var(--Secondary-500, #1d2939);
            transition: width ease-in-out 0.3s;
        }
    }
</style>
